import * as Yup from "yup";
export const CreateBannerShema = Yup.object().shape({
  title: Yup.string().required("Title is required field"),
  description: Yup.string().required("Description is required field"),
});
